<template>
    <div class="chat">

        <el-input v-model="userName" placeholder="用户帐号" style="width: 300px"></el-input>
        <!--<el-input type="textarea" v-model="userName"></el-input>-->
        <el-button type="primary" icon="el-icon-search" @click="searchUser">搜索好友</el-button>

        <!--布局管理器-->
        <el-container class="border" style="height: 500px;margin-top: 30px">
            <el-aside width="210px" class="border">
                <!--好友列表-->
                <div style="width: 200px">
                    <h4>好友列表</h4>
                    <ul class="list_ul" style="list-style: none">
                        <li class="list_ul_li" v-for="(item,index) in friendList" :key="index"
                            @click="selectFriend(item.tbUser.id,item.tbUser.nickName)">
                            <div style="display: inline-flex">
                                <el-avatar :size="40" :src="item.tbUser.avatar"></el-avatar>
                                <div style="margin-left: 16px;margin-top: 10px;cursor: pointer">
                                    {{item.tbUser.nickName}}
                                </div>
                                <div v-if="msgFriendId===item.tbUser.id">
                                    <el-badge is-dot class="item" :hidden="isHidden"></el-badge>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </el-aside>

            <el-aside width="700px" class="right">
                <!--右侧部分-->
                <div style="height: 50px;background: snow">
                    <div v-if="isChatting">
                        {{isChattingFriendName}}
                    </div>
                </div>

                <!--添加好友，点击搜索用户才显示-->
                <div v-if="responseCode===200">
                    <!--如果搜索用户存在-->
                    <div v-if="user">
                        <el-row style="margin-top: 60px">
                            <el-col :span="20">
                                <el-card class="box-card">
                                    <div>
                                        <div style="display: inline-flex">
                                            <el-avatar :size="40" :src="user.avatar"></el-avatar>
                                            <div style="margin-left: 16px;margin-top: -10px"><h4>{{user.username}}</h4>
                                            </div>
                                        </div>

                                        <el-button style="float: right;margin-left: 20px" @click="hideAddFriend" round>
                                            关闭
                                        </el-button>
                                        <el-button type="primary" style="float: right" @click="addFriend(user.id)">
                                            添加好友
                                        </el-button>
                                    </div>
                                    <!--分割线-->
                                    <el-divider></el-divider>
                                    <div>
                                        <div><h4>用户名:{{user.nickName}}</h4></div>
                                        <div><h4>个性签名:{{user.sign}}</h4></div>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>
                    <!--如果搜索用户不存在，给出提示-->
                    <div v-else>
                        <el-row style="height: 100px;margin-top: 60px">
                            <el-col :span="20">
                                <el-card class="box-card">
                                    用户不存在
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>
                </div>

                <!--聊天信息部分-->
                <div>
                    <!--收到的信息：-->
                    <!--<div style="white-space: pre-line">{{message}}</div>-->

                    <!--<el-form style="width: 30%;margin: 0 auto">-->
                    <!--<el-form-item label="活动形式">-->
                    <!--<el-input type="textarea" v-model="msg"></el-input>-->
                    <!--</el-form-item>-->
                    <!--</el-form>-->

                    <router-view></router-view>

                    <!--<div style="position: absolute;bottom: 0px;display: inline-flex">-->
                        <!--<el-input v-model="msg" style="width: 400px"></el-input>-->
                        <!--<el-button type="primary" @click="send">发消息</el-button>-->
                    <!--</div>-->
                </div>
            </el-aside>
        </el-container>

    </div>
</template>

<script>
    import {selectFriendList, searchUser, addFriend} from "@/api/chat";
    import protoc from "../protoc/DataContent_pb.js"

    export default {
        name: "Chat",
        data() {
            return {
                // path: "ws://localhost:8089/hechat",
                path: "ws://118.89.164.56:8089/hechat",
                socket: "",
                message: "",
                msg: "",

                userId: "",
                userName: "",
                user: "",
                userMsg: "",
                responseCode: "",
                friendList: [],
                isChatting: false,
                isChattingFriendId: "",
                isChattingFriendName: "",

                msgUserId:"",
                msgFriendId:"",
                isHidden:false
            }
        },
        created() {
            this.userId = this.$store.state.user.userId;
            this.selectFriendList();
            // 初始化
            this.init()
        },
        mounted() {

        },
        methods: {
            //点击用户
            selectFriend(id, friendName) {
                this.responseCode = ""   //关闭查找好友的页面

                this.isChatting = true
                this.isChattingFriendId = id
                this.isChattingFriendName = friendName  //改变右侧的标题为好友名

                this.isHidden = true

                this.$router.push('/chat/' + this.isChattingFriendId);
            },

            // 根据用户id获取好友列表
            selectFriendList() {
                selectFriendList(this.userId).then(response => {
                    if (response.code === 200) {
                        this.friendList = response.data
                    }
                })
            },

            //搜索好友
            searchUser() {
                if (this.userName === "") {
                    this.$message({
                        showClose: true,
                        message: "请输入用户帐号",
                        type: 'error'
                    });
                } else {
                    searchUser(this.userName).then(response => {
                        if (response.code === 200) {
                            this.responseCode = 200;  //打开查找好友的页面
                            this.user = response.data;
                            this.userMsg = response.msg;

                            this.isChattingFriendName = "查找好友";  //改变右侧的标题为查找好友
                        }
                    })
                }
            },

            //添加好友
            addFriend(friendId) {
                addFriend(this.userId, friendId).then(response => {
                    if (response.code === 200) {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'success'
                        });
                        this.responseCode = ""   //关闭查找好友的页面
                        this.selectFriendList()
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'error'
                        });
                    }
                })
            },

            //关闭查找好友的页面
            hideAddFriend() {
                this.responseCode = ""
            },

            //初始化 web socket
            init() {
                if (typeof(WebSocket) === "undefined") {
                    alert("您的浏览器不支持socket")
                } else {
                    if (this.userId === "" || this.userId === null){
                        this.$message({
                            showClose: true,
                            message: "请先登录",
                            type: 'error'
                        });
                    } else {
                        // 实例化socket
                        this.socket = new WebSocket(this.path)

                        this.$store.dispatch("setWebsocket",this.socket).then()

                        // 监听socket连接,连接socket时触发
                        this.socket.onopen = this.open
                        // 监听socket错误信息，出现错误的时候触发
                        this.socket.onerror = this.error
                        // 监听socket消息，收到服务器端回送的消息
                        this.socket.onmessage = this.getMessage
                        //设置获取socket的类型
                        this.socket.binaryType = "arraybuffer";
                    }
                }
            },
            //连接服务端,注册channel
            open: function () {
                console.log("socket连接成功")
                //构建chatMsgProtoc
                const chatMsgProtoc = this.GLOBAL.chatMsgProtoc(this.userId, null, null, null);
                //构建dataContentProtocBytes,给服务发送信息，定义action=1
                const dataContentProtocBytes = this.GLOBAL.dataContentProtocBytes(1, chatMsgProtoc, null);
                //发送userId，和channel匹配
                this.socket.send(dataContentProtocBytes)
            },
            //获取服务端返回的信息
            getMessage: function (msg) {
                var chatMsgResponse = new protoc.DataContent.ChatMsgContent.deserializeBinary(msg.data)
                this.message += chatMsgResponse.getMsgcontent() + "\n";
                this.msgUserId = chatMsgResponse.getUserid();
                this.msgFriendId = chatMsgResponse.getTalkid();
            },
            // //发送信息给服务端
            // send: function () {
            //     //通过socket给服务端发送信息,定义action=2
            //     //构建chatMsgProtoc
            //     const chatMsgProtoc = this.GLOBAL.chatMsgProtoc(this.userId, this.isChattingFriendId, this.msg, null);
            //     //构建dataContentProtocBytes,给服务发送信息，定义action=1
            //     const dataContentProtocBytes = this.GLOBAL.dataContentProtocBytes(2, chatMsgProtoc, null);
            //     //向服务端发送数据，服务端再转发给好友
            //     this.socket.send(dataContentProtocBytes)
            //     //清空输入框数据
            //     this.msg = ""
            // },
            //出现错误的时候
            error: function () {
                console.log("连接错误")
            },
        },

        //断开连接的时候
        destroyed() {
            // 销毁监听，断开socket时触发
            this.socket.onclose = this.close
            console.log("websocket已断开")
        }
    }
</script>

<style scoped>
    .chat {
        width: 60%;
        margin: 0 auto;
    }

    /*设置鼠标悬浮样式（好友列表）*/
    .list_ul {
        list-style: none;
        margin: 0px;
        padding: 0px;
    }

    .list_ul_li {
        font-size: 16px;
        color: #000;
        /*display: inline-block;*/
        /*text-align: left;*/
        list-style: none;
        /*padding: 0 30px 0 0;*/
    }

    .list_ul_li:hover {
        background: #E4E6E9;
        border-radius: 9px;
    }

    .list_ul-active li {
        background: #E4E6E9;
        color: white;
    }

    /*右侧部分*/
    .right{
        /*border: 1px solid black;*/
        position: relative;
    }
    .border{
        /*border: 1px solid black;*/
    }
</style>
